import ArchitectureDesignForm from "../component/ArchitectureDesignForm";

const CorporateArchitectureDesignCreate = () => {
  return <ArchitectureDesignForm isEditMode={false} />;
};

export default CorporateArchitectureDesignCreate;
